'use strict'

function miniflat(value) {
  return value === null || value === undefined
    ? []
    : 'length' in value
    ? value
    : [value]
}

module.exports = miniflat



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/miniflat.js
// module id = 435
// module chunks = 0